import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';

export const interactive = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['interactive'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    return {
      neutral: {
        default: tokens['--semantic-bg-interactive-neutral-default'],
        hover: tokens['--semantic-bg-interactive-neutral-hover'],
        active: tokens['--semantic-bg-interactive-neutral-active'],
        disabled: tokens['--semantic-bg-interactive-neutral-disabled'],
        focus: tokens['--semantic-bg-interactive-neutral-focus'],
      },
    };
  }

  // we shouldn't hit this as the code path is gated, setting everything to red
  // so that we can see if something is wrong
  return {
    neutral: {
      default: '#FF0000',
      hover: '#FF0000',
      active: '#FF0000',
      disabled: '#FF0000',
      focus: '#FF0000',
    },
  };
};
